import axios from 'axios';

const API_URL = 'http://localhost:5000/api';

// Get all active tours
export const getAllTours = async () => {
  try {
    const response = await axios.get(`${API_URL}/tours`);
    return response.data;
  } catch (error) {
    console.error('Error fetching tours:', error);
    throw error;
  }
};

// Get tour details by ID
export const getTourById = async (tourId) => {
  try {
    const response = await axios.get(`${API_URL}/tours/${tourId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching tour details:', error);
    throw error;
  }
};

// Get price estimate for a tour
export const getTourPriceEstimate = async (tourId, date, persons, vehicleType = 'car') => {
  try {
    const response = await axios.get(`${API_URL}/tour-bookings/price-estimate`, {
      params: {
        tourId,
        date,
        persons,
        vehicleType
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching tour price estimate:', error);
    throw error;
  }
};

// Book a tour
export const bookTour = async (tourBookingData) => {
  try {
    const response = await axios.post(`${API_URL}/tour-bookings`, tourBookingData);
    return response.data;
  } catch (error) {
    console.error('Error booking tour:', error);
    throw error;
  }
};

export default {
  getAllTours,
  getTourById,
  getTourPriceEstimate,
  bookTour
};
